module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "tabBox"
  }, [_c('el-table', {
    staticStyle: {
      "width": "100%",
      "text-align": "center"
    },
    attrs: {
      "data": _vm.arrList,
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.check_risk
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "name",
      "align": "center",
      "label": "名称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "align": "center",
      "label": "性别"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "出生年月"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('span', [_vm._v(_vm._s(_vm.timeFormat(scope.row.birthday)))])]
      }
    }])
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "professionDuty",
      "align": "center",
      "label": "职称"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "unitName",
      "align": "center",
      "label": "工作单位"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "provinceName",
      "align": "center",
      "label": "所属省"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "cityName",
      "align": "center",
      "label": "所属市"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "countyName",
      "align": "center",
      "label": "所属县"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "professionalField",
      "align": "center",
      "label": "技术领域特长"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "mobilePhone",
      "align": "center",
      "label": "手机号码"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "expertType",
      "align": "center",
      "label": "备注"
    }
  })], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-78cdaf4c","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/manage/expert/experList.vue
// module id = 1252
// module chunks = 2